import { genericMemo } from "@redotech/react-util/component";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";

export const ConditionInput = genericMemo(function ConditionInput<
  CONDITION_KIND,
>({
  selectConditionParams,
  line1Fields,
  line2Fields,
  line3Fields,
}: {
  selectConditionParams: {
    conditionKind: CONDITION_KIND | undefined;
    setConditionKind: (conditionKind: CONDITION_KIND) => void;
    options: RedoListItem<CONDITION_KIND>[];
  };
  line1Fields: React.ReactNode | null;
  line2Fields: React.ReactNode | null;
  line3Fields: React.ReactNode | null;
}) {
  const { t } = useTranslation();
  return (
    <>
      <Flex align="center" dir="row" gap="md" wrap="wrap">
        <Text fontSize="xs" fontWeight="medium">
          {t("If")}
        </Text>
        <RedoSingleSelectDropdownInput<CONDITION_KIND>
          fitToAnchor={false}
          flexGrow={false}
          options={selectConditionParams.options}
          optionSelected={({ item }) =>
            selectConditionParams.setConditionKind(item.value)
          }
          placeholder={t("Select a field")}
          selectedItem={selectConditionParams.options.find(
            (o) => o.id === selectConditionParams.conditionKind,
          )}
          size="xs"
        />
        {line1Fields}
      </Flex>
      {line2Fields}
      {line3Fields}
    </>
  );
});
